import css from "../../css/listing/snapshot.module.css";

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { differenceInDays, parseISO } from "date-fns";
import { convertSquareFeetToAcres } from "../../service/listing";
import Separator from "../common/Separator";
import Row from "./Row";
import MultiListDetails from "./MultiListDetails";
import Details from "./Details";

const Snapshot = (props) => {
    const { listing } = props;

    const [days, setDays] = useState(null);

    useEffect(() => {
        setDays(differenceInDays(new Date(), parseISO(listing.listed_date)));
    }, [listing.listed_date]);

    const { participant } = listing;
    const { lot_size, living_area } = listing;

    return (
        <div className={css.snapshot}>
            <Row
                label="Type"
                value={listing.type.label}
                label2="Category"
                value2={listing.category.label}
            />
            <Row
                label="Property Type"
                value={listing.property_type.label}
                label2="Property Subtype"
                value2={listing.property_sub_type.label}
            />
            <Row
                label="MLS Number"
                value={
                    participant
                        ? participant.mls && participant.mls.number
                        : listing.mls_number
                }
                label2="Parcel Number"
                value2={listing.parcel_number}
            />
            <Row
                label="Property Sqft"
                value={
                    living_area > 0 ? (
                        <>{living_area.toLocaleString()} sqft</>
                    ) : (
                        ""
                    )
                }
                label2="Lot Size"
                value2={
                    lot_size && lot_size > 0 ? (
                        <>
                            {convertSquareFeetToAcres(
                                lot_size
                            ).toLocaleString()}{" "}
                            acres
                        </>
                    ) : (
                        ""
                    )
                }
            />
            <Row
                label="Year Built"
                value={listing.year_built}
                label2="Year Updated"
                value2={listing.year_updated}
            />
            <Row
                label="Days On Market"
                value={days}
                label2="Elevation"
                value2={listing.elevation}
            />
            <Row
                label="Bedrooms"
                value={listing.bedrooms}
                label2="Bathrooms"
                value2={listing.bathrooms}
            />
            {listing.source === "user" && (
                <Row
                    label="Source"
                    value={
                        listing.agent
                            ? "Listing Agent / Residential.com"
                            : "Owner"
                    }
                />
            )}

            <Separator topMargin={true} />
            <Details listing={listing} />

            {(listing.location_directions ||
                listing.legal_description ||
                listing.subdivision_name ||
                listing.franchise_affiliation ||
                listing.geocode_options) && <Separator topMargin={true} />}
            <Row
                label="Location Directions"
                value={listing.location_directions}
            />
            <Row label="Legal Description" value={listing.legal_description} />
            <Row label="Subdivision Name" value={listing.subdivision_name} />
            <Row
                label="Franchise Affiliation"
                value={listing.franchise_affiliation}
            />
            <Row label="Geocode Options" value={listing.geocode_options} />

            <Separator topMargin={true} />
            <MultiListDetails listing={listing} />
        </div>
    );
};

Snapshot.propTypes = {
    listing: PropTypes.object.isRequired,
};

export default Snapshot;
